
<div class="mt-3 mb-2 mb-3 form-inline">
  <h5 class="col" i18n>Documents</h5>
  <button class="btn btn-bidit-submit float-right" (click)="addDocument()" i18n>Add Document</button>
</div>

  <div *ngFor="let document of documents">
    <div class="card border-bidit-dark bg-light mb-3 shadow">
      <div class="card-body">
        <div class="row mb-2">
          <span class="col-7 text-bidit-primary-header">{{_quote.quote_Name}}</span>
          <div class="col-5">
            <div class="float-right">
              <button type="button" class="btn btn-bidit-edit mr-2" (click)="editDocument(document)"></button>
              <button type="button" class="btn btn-bidit-download mr-2" (click)="downloadAttachment(document)"></button>
              <button type="button" class="btn btn-bidit-delete" (click)="deleteDocument(document)"></button>
            </div>
          </div>
        </div>
        <p>
          <span>{{document.note_Text}}</span>
        </p>
        <p>
          <span><span i18n>File Name:</span> {{document.quoteNote_Text}}</span>
        </p>
        <div>
          <span class="text-bidit-primary"><span i18n>Created by</span> {{document.createdBy.firstName}} {{document.createdBy.lastName}} on {{document.quoteNote_Created | date: 'M/d/yyyy'}} </span>
        </div>
      </div>
    </div>
  </div>
